import React from 'react';
import { connect } from 'react-redux';
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond/dist/filepond.min.css';
import styled from 'styled-components';
import { Button } from '../../ui';
// import Continue from '../../Common/Continue';
import iconFolder from '../../../assets/icons/icon-folder.svg';
import iconSuccess from '../../../assets/icons/icon-success.svg';
import iconAlert from '../../../assets/icons/icon-alert.svg';
import Form from './Form.styles';
import Checkbox from './Checkbox';
import { rental } from "../../../operations";
import { setRentalValue, clean } from '../../../actions';
import Loader from '../../Common/Loader';

registerPlugin(FilePondPluginFileValidateSize);
registerPlugin(FilePondPluginFileEncode);
registerPlugin(FilePondPluginFileValidateType);

const AttachedWrapper = styled.div`
  .filepond--item {
    margin-bottom: 10px !important;
  }

  .filepond--file {
    padding: 0.5625em !important;
    font-size: 18px !important;
  }

  .Attached {
    &-body {
      text-align: left;

      h3 {
        text-align: left;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 1em;
        color: var(--text-color-2);
      }

      strong {
        font-weight: bold;
      }

      em {
        font-style: italic;
      }

      p,
      ul {
        font-size: 15px;
      }

      p {
        margin-bottom: 1em;
      }

      ul {
        list-style: disc;
        margin-left: 1.5em;
      }

      li {
        margin-bottom: 0.5em;
      }

      ul ul {
        list-style: square;
        margin-top: 0.5em;
      }
    }

    &-files {
      font-size: 15px;

      span + span {
        margin-left: 20px;
      }
    }
  }
`;

function Attached(props) {
  const {
    sendMail,
    clean,
    finished,
    finishedStatus,
    isLoading,
    onValueChange
  } = props;
  const [files, setFiles] = React.useState([]);

  const handleFiles = fileItems => {
    setFiles(fileItems);
  };

  const handleSendInfo = () => {
    let filesArray = [];

    files.forEach(fileItem =>
      filesArray.push({
        file: fileItem?.file?.name,
        base64: fileItem.getFileEncodeBase64String()
      })
    );

    onValueChange('attachments', filesArray);
    sendMail();
  };

  if (isLoading) {
    return (
      <AttachedWrapper>
        <Loader message='' />
      </AttachedWrapper>
    )
  }

  const handleLastBack = () => {
    onValueChange('finished', false);
    onValueChange('finishedStatus', { error: true, message: '' });
  }

  const handleRestart = () => {
    clean();
  }

  if (finished) {
    return (
      <AttachedWrapper>
        {finishedStatus.error ? (
          <img src={iconAlert} alt="Error" width={80} />
        ) : (
          <img src={iconSuccess} alt="Éxito" width={80} />
        )}

        <p style={{ fontSize: 24, marginTop: 20, marginBottom: 30 }}>
          {finishedStatus.message}
        </p>

        {finishedStatus.error ? (
          <p>
            <Button onClick={handleLastBack} secondary>Volver</Button>
          </p>
        ): (
          <p>
            <Button onClick={handleRestart}>Finalizar</Button>
          </p>
        )}
      </AttachedWrapper>
    )
  }

  return (
    <AttachedWrapper>
      <Form>
        <div className="Form-title">Adjuntos</div>
        <div className="Attached-body">
          <h3>Particulares</h3>
          <p>Documentación a adjuntar:</p>

          <ul>
            <li>Formulario de solicitud</li>
            <li>Cédula de Identidad</li>
            <li>Copia de contrato de arrendamiento</li>
            <li>Copia de inventario firmado por ambas partes</li>
            <li>
              Últimos 3 recibos de pago del arrendamiento actual (en caso que se
              trate de un contrato ya vigente).
            </li>
            <li>
              Comprobante de ingresos (según situación laboral)
              <ul>
                <li>
                  <em>Jubilados o pensionistas:</em> Recibo de jubilación /
                  pensión del último mes
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div className="Form-row" style={{ margin: '2rem 0' }}>
          <div className="Form-col" style={{ fontSize: 16 }}>
            <FilePond
              files={files}
              labelIdle={`Arrastra y suelta tus archivos aquí o <span class="filepond--label-action">selecciona archivos</span>`}
              allowMultiple={true}
              allowFileSizeValidation={true}
              maxFileSize={'3MB'}
              maxTotalFileSize={'10MB'}
              labelMaxFileSizeExceeded={`El archivo es demasiado grande`}
              labelMaxFileSize={`El tamaño máximo de archivo es {filesize}`}
              labelMaxTotalFileSizeExceeded={`Tamaño total máximo excedido`}
              labelMaxTotalFileSize={`El tamaño total máximo de los archivos es {filesize}`}
              maxFiles={30}
              onupdatefiles={fileItems => handleFiles(fileItems)}
              allowFileEncode={true}
              labelFileTypeNotAllowed="Tipo de archivo no permitido"
              acceptedFileTypes={['image/jpg', 'image/jpeg', 'application/pdf']}
            />

            <p
              style={{
                textAlign: 'center',
                fontSize: 12,
                color: 'var(--text-color-2)',
                marginTop: 6
              }}
            >
              Los archivos adjuntos deben ser menor a 3MB y no pueden superar
              los 10MB en total. <br/>
              Solo se admiten archivos del tipo documento <strong>PDF</strong> o imágenes <strong>JPG</strong>. <br/>
              Se podrán adjuntar en total hasta 30 archivos.
            </p>
          </div>
        </div>

        <div className="Attached-body" style={{ marginBottom: '3rem' }}>
          <p>Una vez aprobada la solicitud para retirar, entregar:</p>

          <ul>
            <li>
              Carta poder o de administración en caso de que firme un tercero en
              representación del arrendador.
            </li>
            <li>Carta de subrogación firmada por el propietario.</li>
            <li>Carta de legitimación firmada por los inquilinos.</li>
            <li>Formulario de Solicitud firmada por inquilino.</li>
          </ul>
        </div>

        <Button disabled={files.length === 0} onClick={handleSendInfo}>Solicitar</Button>
      </Form>
    </AttachedWrapper>
  );
}

const mapStateToProps = state => {
  return {
    finished: state.rental.finished,
    finishedStatus: state.rental.finishedStatus,
    isLoading: state.steps.isInnerLoading
  }
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: (type, value) => {
      dispatch(setRentalValue(type, value));
    },
    sendMail: () => {
      dispatch(rental.sendMail());
    },
    clean: () => {
      dispatch(clean());
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Attached);
